import { useIsMobile } from '@/hooks/useMobile';

import { FooterDesktop } from './FooterDesktop';
import { FooterMobile } from './FooterMobile';

export const Footer = () => {
  const isMobile = useIsMobile();

  return isMobile ? <FooterMobile /> : <FooterDesktop />;
};
